import { jwtDecode } from "jwt-decode";
import type { RouteLocationNormalized } from "vue-router";
import Application from "~/utils/config";

const PROTECTED_ROUTES = [
  // Matches account routes except for /login, /signup, /password-reset, /reset-password
  /^(\/[a-z]{2}-[a-z]{2})?(\/account)(?!\/(login|signup|password-reset|reset-password|verify-email)\/?$).*/i,
];

function checkIsProtectedRoute(route: RouteLocationNormalized) {
  return PROTECTED_ROUTES.some((x) => x.test(route.path));
}

export default defineNuxtRouteMiddleware((to) => {
  const isProtectedRoute = checkIsProtectedRoute(to);
  if (!isProtectedRoute) return;

  let sessionToken: string | null | undefined;
  if (import.meta.server) {
    sessionToken = useNuxtApp().ssrContext?.event?.context?.b2kSessionToken as string | null | undefined;
  } else {
    sessionToken = useCookie(Application.Cookies.authSession).value;
  }

  if (!sessionToken) {
    const localePath = useLocalePath();
    return navigateTo(localePath("/account/login"));
  }

  const jwtToken = jwtDecode(sessionToken);
  const expiry = new Date((jwtToken.exp ?? 0) * 1000);
  const now = new Date();

  if (expiry < now) {
    const localePath = useLocalePath();
    return navigateTo(localePath("/account/login"));
  }
});
